<mat-card>
  <p>
    Välkommen till Sparbanken Syds dokumentportal, där du kan komplettera med
    dokument som banken har efterfrågat i ditt ärende. När du använder denna
    tjänst behandlar och lagrar vi de personuppgifter du överför genom portalen
    i enlighet med våra dataskyddsprinciper.
  </p>

  <p [style.margin-bottom]="0">Läs mer här:
    <a
      spbAccessibleLink
      href="https://www.sparbankensyd.se/privat/om-oss/sakerhet-kundskydd/kundkannedom-och-kundskydd"
      target="_blank">
      Så här tar vi hand om dina personuppgifter.
    </a>
  </p>
</mat-card>